export default __webpack_public_path__ + "static/media/Calendar.0a0cd2da.svg";